import { RemoteParticipant, Room } from "@domain";
import { SyncInteractor } from "@kernel/frontend-react-app";

export interface RemoveRemoteParticipantInteractorProps {
  remoteId: number;
  room: Room;
}

export class RemoveRemoteParticipantInteractor extends SyncInteractor<
  RemoveRemoteParticipantInteractorProps,
  Room
> {
  public execute(props: RemoveRemoteParticipantInteractorProps): Room {
    const participant = props.room.getRemoteParticipant(
      props.remoteId
    ) as RemoteParticipant;
    if (participant === null) return props.room;
    props.room.leaveRemoteParticipant(participant);
    return Room.createFromRoom(props.room);
  }

  public static create() {
    return new RemoveRemoteParticipantInteractor();
  }
}
